(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpSearchInputText', cpSearchInputText);

    cpSearchInputText.$inject = [];

    function cpSearchInputText() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/search-input-text/search-input-text.html',
            scope: {
                type: '@',
                object: '=',
                prop: '@',
                onChange: '&?'
            },
            link: function(scope, element, attrs, controller) {

            }
        };
    }
})();

